module.exports = __webpack_public_path__ + "static/media/Loyalty.1f8757f9.svg";